import TicketService, {ITicketCreate} from "../../api/ticketService";
import {toastError} from "../../component/shared/toast/Toast";
import {getSafeBackendErrorMessage} from "../../util/utils";
import WishService from "../../api/wishService";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {updateUserAfterObtainingEntries} from "../auth/Slice";
import {checkWishToRemove} from "../wishlist/Slice";
import {reloadWishAfterAction} from "../wish/Slice";

export const obtainEntries =
    createAsyncThunk(`${SliceNames.TICKET}/obtainEntries`,
        async (req: {
            body: ITicketCreate,
            updateHasParticipated: () => void
        }, thunkAPI) => {
            try {
                await TicketService.obtainEntries(req.body)
                const res = await WishService.fetchWishDetails(req.body.wish_id)
                thunkAPI.dispatch(updateUserAfterObtainingEntries(
                    {
                        qty: req.body.ticket_count,
                        wish: res.data,
                    }
                ))
                thunkAPI.dispatch(checkWishToRemove(res.data))
                thunkAPI.dispatch(reloadWishAfterAction(res.data))
                req.updateHasParticipated()
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                WishService.fetchWishDetails(req.body.wish_id)
                    .then((res) => {
                        thunkAPI.dispatch(reloadWishAfterAction(res.data));
                        thunkAPI.dispatch(checkWishToRemove(res.data));
                    })
                return thunkAPI.rejectWithValue(e)
            }
        })


export const getTicketsForUser = createAsyncThunk(`${SliceNames.TICKET}/getTicketsForUser`,
    async (wishId: string, thunkAPI) => {
        try {
            const res = await TicketService.fetchTicketsForUser(wishId)
            return res.data
        } catch (e) {
            return thunkAPI.rejectWithValue(e)
        }
    })